import { gsap } from "gsap";
import { Modal, Tab } from "bootstrap";

// TODO: Mobile menu modal styling
// TODO: Mobile header
// TODO: Language switcher modal window - mobile
// TODO: Langauge switcher on desktop - styling the dropdown
// TODO: Login modal window - desktop/mobile
// TODO: Search modal window - desktop/mobile
// eslint-disable padded-blocks
const initHeaderModal = () => {
  let modalOpen = false;
  let activeSubmenu;
  const isMobile = window.matchMedia("(max-width: 1024px)").matches;
  const modalEl = document.querySelector(".js-header-menu-modal");
  const modalBody = modalEl.querySelector(".header-menu-modal-body-wrapper");
  const desktopMenu = document.querySelector(".header-navbar-wrapper .navbar-menu");
  const desktopMenuItems = desktopMenu.querySelectorAll(".nav-link");
  const modalMenuItems = modalEl.querySelectorAll(".header-menu-modal-navbar-wrapper .nav-link");
  const modalNavTabs = [];
  const modalNavTabElements = [];
  const toFirstLevelButtons = modalEl.querySelectorAll(".js-header-menu-modal-to-first-level");

  // eslint-disable-next-line no-undef
  const modal = new Modal(modalEl, {
    backdrop: true,
    keyboard: true,
    focus: true,
  });

  const initMobileTabContentHeight = () => {
    if (!isMobile) return;
    const modalHeader = modalEl.querySelector(".modal-header");
    const tabHeader = modalEl.querySelector(".js-header-menu-modal-tab-header-wrapper");
    const tabContent = modalEl.querySelectorAll(".js-header-menu-modal-content");
    const modalHeight = modalEl.getBoundingClientRect().height;
    const modalHeaderHeight = modalHeader?.getBoundingClientRect().height;
    const tabHeaderHeight = tabHeader?.getBoundingClientRect().height;
    const tabContentHeight = modalHeight - modalHeaderHeight - tabHeaderHeight;

    tabContent.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${tabContentHeight}px`;
    });
  };

  // First level - left column
  const initModalNavTabs = () => {
    modalMenuItems.forEach((el) => {
      if (el.dataset.submenu) {
        // eslint-disable-next-line no-undef
        const tabTrigger = new Tab(el);
        modalNavTabs.push(tabTrigger);
        modalNavTabElements.push(el);

        el.addEventListener("shown.bs.tab", () => {
          // eslint-disable-next-line 
          initMobileTabContentHeight();
        });
      }
    });
  };

  const toggleActivePanel = () => {
    const activePanel = modalEl.querySelector(`[data-submenu='${activeSubmenu}']`);
    // eslint-disable-next-line no-undef
    const tab = Tab.getInstance(activePanel);
    tab.show();
    initMobileTabContentHeight();
  };

  const copyTopMenuToModal = () => {
    if (!isMobile) return;
    const topMenu = document.querySelectorAll(".header-topbar-menu");
    if(modalEl.querySelector(".js-header-menu-modal-footer-links-wrapper") !== undefined)
      return;
    
    topMenu.forEach((el, i) => {
      if (i === 0) {
        el.classList.add("header-menu-modal-top-navbar");
        modalEl.querySelector(".js-header-menu-modal-footer-links-wrapper").appendChild(el);
      }
    });
  };

  copyTopMenuToModal();
  initModalNavTabs();

  desktopMenuItems.forEach((item) => {
    item.addEventListener("click", () => {
      const submenuID = item.dataset.submenu;

      if (submenuID) {
        activeSubmenu = submenuID;
        toggleActivePanel();
        modal.show();
      } else {
        activeSubmenu = null;
      }
    });
  });

  // Mobile open btn
  document.querySelector(".js-header-menu-modal-open-btn").addEventListener("click", () => {
    modal.show();
  });

  /* Animation sequence:
    1. Hide current level
    2. Set footer height to 0
    3. Show next level
    */
  let currentLevel = "first"; // Possible options: first, second
  const switchLevelTl = gsap.timeline({
    repeat: 0,
    paused: true,
  });

  switchLevelTl.to(
    ".js-header-menu-modal-footer-wrapper",
    {
      height: 0,
      display: "none",
      duration: 0.3,
    },
    0,
  );
  switchLevelTl.to(
    ".js-header-modal-navbar-wrapper",
    {
      x: "-120%",
      duration: 0.3,
    },
    0,
  );
  switchLevelTl.to(
    ".js-header-modal-content-wrapper",
    {
      x: "0",
      duration: 0.3,
    },
    0,
  );

  const mobileSwitchLevel = () => {
    if (!isMobile) return;

    switch (currentLevel) {
      case "first":
        switchLevelTl.restart();
        currentLevel = "second";
        modalBody.classList.remove("--first-level");
        break;
      case "second":
        switchLevelTl.reverse();
        currentLevel = "first";
        modalBody.classList.add("--first-level");
        break;
      default:
        break;
    }
  };

  modalNavTabElements.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (modalOpen) {
        mobileSwitchLevel();
      }
    });
  });

  toFirstLevelButtons.forEach((el) => {
    el.addEventListener("click", () => {
      mobileSwitchLevel();
    });
  });

  modalEl.addEventListener("shown.bs.modal", () => {
    initMobileTabContentHeight();
    modalOpen = true;
  });

  modalEl.addEventListener("hide.bs.modal", () => {
    // modalEl.classList.remove("slide-from-right--active");
    modalOpen = false;

    switchLevelTl.restart().pause();
    currentLevel = "first";
    if (!modalBody.classList.contains("--first-level")) {
      modalBody.classList.add("--first-level");
    }
  });
};

export default initHeaderModal;
